import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setErr("La contraseña debe tener al menos 8 caracteres.");
    if (pw !== pw2) return setErr("Las contraseñas no coinciden.");
    setBusy(true); setErr("");
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); }
    catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-[#FAF7F2] p-6">
      <div className="w-full max-w-sm" data-testid="admin-reset-page">
        <p className="eyebrow">Panel privado</p>
        <h1 className="mt-2 font-serif text-4xl">Nueva contraseña</h1>
        {!token ? <p className="mt-6 text-sm text-red-600" data-testid="reset-error">Enlace inválido. Solicita uno nuevo desde la página de ingreso.</p>
          : done ? (
            <div className="mt-6 space-y-4" data-testid="reset-success">
              <p className="text-sm">Tu contraseña fue actualizada. Ya puedes ingresar al panel.</p>
              <Link to="/admin/login" className="block text-center rounded-full bg-[#5E6B52] text-white py-3 font-semibold" data-testid="reset-go-login">Ir a ingresar</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div><Label htmlFor="p1">Nueva contraseña</Label>
                <Input id="p1" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 h-12 rounded-xl bg-white" data-testid="reset-password-input" /></div>
              <div><Label htmlFor="p2">Repite la contraseña</Label>
                <Input id="p2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5 h-12 rounded-xl bg-white" data-testid="reset-password-confirm-input" /></div>
              {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
              <button disabled={busy} className="w-full h-12 rounded-full bg-[#5E6B52] text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60" data-testid="reset-submit-btn">
                {busy && <Loader2 className="h-4 w-4 animate-spin" />} Guardar contraseña
              </button>
            </form>
          )}
      </div>
    </div>
  );
}
